import { ReactNode, CSSProperties } from 'react';
import { FormItemProps, FormInstance } from 'antd/lib/form';

export const DEFAULT_STYLE: CSSProperties = { width: '100%' };

export interface BaseSimpleFormProps extends FormItemProps {
  /** form 控制实例 */
  form?: FormInstance;
  /** 禁用时展示文字 */
  disabledRender?: ReactNode;
  /** 图片相对路径字段 */
  relativePathName?: string;
  /** 关联表单字段名称 只有表单类型为 Cascader SuperSelect SuperSelectTable 有效 */
  associationName?: string;
  /** 选项取行数据的哪个字段 */
  optionFieldName?: string;
}

export enum SimpleFormItemEnum {
  SimpleFormInput = 'SimpleFormInput',
  SimpleFormInputNumber = 'SimpleFormInputNumber',
  SimpleFormSwitch = 'SimpleFormSwitch',
  SimpleFormSelect = 'SimpleFormSelect',
  SimpleFormSuperSelect = 'SimpleFormSuperSelect',
  SimpleFormSelectTable = 'SimpleFormSelectTable',
  SimpleFormSuperSelectTable = 'SimpleFormSuperSelectTable',
  SimpleFormTextArea = 'SimpleFormTextArea',
  SimpleFormDatePicker = 'SimpleFormDatePicker',
  SimpleFormRangePicker = 'SimpleFormRangePicker',
  SimpleFormTimePicker = 'SimpleFormTimePicker',
  SimpleFormCheckboxGroup = 'SimpleFormCheckboxGroup',
  SimpleFormCheckbox = 'SimpleFormCheckbox',
  SimpleFormAddress = 'SimpleFormAddress',
  SimpleFormUpload = 'SimpleFormUpload',
  SimpleFormUploadImage = 'SimpleFormUploadImage',
  SimpleFormUploadImages = 'SimpleFormUploadImages',
  SearchFormOperation = 'SearchFormOperation',
  simpleFormCascader = 'simpleFormCascader',
  SimpleFormSelectCustom = 'SimpleFormSelectCustom',
  SimpleFormDropdownTable = 'SimpleFormDropdownTable',
  SimpleFormDropdownSyncTable = 'SimpleFormDropdownSyncTable',
  SimpleFormSuperSelectCombination = 'SimpleFormSuperSelectCombination',
  SimpleFormSuperAutoComplete = 'SimpleFormSuperAutoComplete',
}
